import { isApiRequestError } from "./apiRequestError";
import { isServerConnectionError } from "./serverConnectionErrors";

function errorMessage(err: unknown): string {
  if (typeof err === "string") return err;
  if (err instanceof Error) return err.message;
  return "";
}

/**
 * True when billing status failed with a genuine subscription gate (402).
 * Every other billing load failure should show the downtime page, not the paywall.
 */
export function isBillingSubscriptionRequiredFailure(err: unknown): boolean {
  if (isApiRequestError(err) && err.status === 402) {
    return true;
  }
  const message = errorMessage(err);
  return /subscription required|require_tier1_access/i.test(message);
}

/**
 * Billing status could not be loaded reliably — show `/service-unavailable`, not `/paywall`.
 */
export function isBillingStatusUnreachable(err: unknown): boolean {
  if (!err) return false;
  if (isBillingSubscriptionRequiredFailure(err)) return false;
  if (isServerConnectionError(err)) return true;
  return true;
}
